module.exports = __webpack_public_path__ + "static/media/cv.c823e988.svg";